import React from "react";
import styles from "./index.module.css";

const FormContainer = ({ children, className = "" }) => {
  return <div className={`${styles["form-container"]} ${className}`}>{children}</div>;
};

export default FormContainer;
